import { AutogenModelStatetaxLookupModel, AutogenRowStatetaxLookupModel } from "./autogen/AutogenModelStatetaxLookupModel";

export class ModelStatetaxLookupModel extends AutogenModelStatetaxLookupModel<RowStatetaxLookupModel> {
	constructor() {
		super(RowStatetaxLookupModel);
	}
}

export class RowStatetaxLookupModel extends AutogenRowStatetaxLookupModel {
}